module.exports = __webpack_public_path__ + "static/img/img-3-3.29626e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-3-3.png
// module id = sVo1
// module chunks = 0